<template lang="pug">
    .app-wrapper
        sidebar.sidebar-container
        .main-container
            navbar
            app-main
</template>
<script>
import { Navbar, Sidebar, AppMain } from './components'

export default {
  name: 'Layout',
  components: { Navbar, Sidebar, AppMain }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.sidebar-container {
  overflow: auto;
}
.app-wrapper {
  // @include clearfix;
  position: relative;
  height: 100%;
  width: 100%;
  &.mobile.openSidebar {
    position: fixed;
    top: 0;
  }
}
.drawer-bg {
  background: #000;
  opacity: 0.3;
  width: 100%;
  top: 0;
  height: 100%;
  position: absolute;
  z-index: 999;
}
.app-main {
  margin: 10px;
}
</style>
